import ButtonComp from '../components/buttons/button';
import { connect } from 'react-redux';
import { personSearchEnable } from './actions';

const mapStateToPropsRes = (state) => {
  return {
    enabled: state.personSearch.enabled,
    text: window.displayText('PERSON_SEARCH')
  };
};

const mapDispatchToPropsRes = (dispatch) => {
  return {
    onClick: () => { 
        dispatch(personSearchEnable(true));
    }
  };
};

const TogglePersonSearch = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(ButtonComp);

export default TogglePersonSearch;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/personSearch/containerToggle.js